import { useCallback } from "react";
import { useCodebaseStore } from "@/store/zustand/codebaseStore";
import { useCreateComponentModalStore } from "@/store/zustand/createComponentModalStore";
import { useSelectedNavTreeNode } from "@/components/Canvas/stores/canvasStore";
import { JsxElementType } from "@/utils/jsx/jsxElementTypes";
import { toast } from "sonner";

export const useCreateComponent = () => {
  const { selectedElement } = useSelectedNavTreeNode();
  const treeElementLookup = useCodebaseStore(
    (state) => state.treeElementLookup,
  );

  const selectedTreeElement = selectedElement?.isKnownElement()
    ? treeElementLookup?.[selectedElement.codebaseId]
    : null;

  return useCallback(() => {
    if (
      !selectedTreeElement ||
      selectedTreeElement.type !== JsxElementType.Element
    ) {
      toast.error("Can only create components from HTML elements");
      return;
    }

    useCreateComponentModalStore.getState().openModal({
      codebaseId: selectedTreeElement.codebaseId,
      filename: selectedTreeElement.filename,
      jsxName: selectedTreeElement.jsxName,
      contentsStart: selectedTreeElement.contentsStart,
      contentsEnd: selectedTreeElement.contentsEnd,
    });
  }, [selectedTreeElement]);
};
